import { render } from "./standTouch.vue?vue&type=template&id=29fb3aaf&scoped=true"
import script from "./standTouch.vue?vue&type=script&lang=js"
export * from "./standTouch.vue?vue&type=script&lang=js"

import "./standTouch.vue?vue&type=style&index=0&id=29fb3aaf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29fb3aaf"]])

export default __exports__